import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import OrderServices from "../based/services/OrderServices";
import { INITPAGING } from "../based/Constants";
import Common from "../based/Common";

//tất cả/đợi hoàn/thành công/đã hủy
const TAB_SCREEN = [
    { label: "Tất cả", value: -1 },
    { label: "Đợi hoàn", value: 0 },
    { label: "Thành công", value: 1 },
    { label: "Đã hủy", value: 2 },
    { label: "Bị từ chối", value: 3 },
];

function RefundManagementOverview(props) {
    const [models, setModels] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING, status: -1 });

    console.log("models", models);

    useEffect(() => {
        getData(paging);
    }, []);

    const _renderTab = useMemo(() => (
        <ul className="nav nav-tabs tabs-bordered">
            {TAB_SCREEN.map((item, index) => {
                return (
                    <li key={index} className="nav-item">
                        <a className={paging.status == item.value ? "nav-link active" : "nav-link btn-light"} onClick={() => getData({ ...paging, status: item.value })}>
                            <span>{item.label}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    ));

    const getData = async (page) => {
        const [err, data] = await OrderServices.GetOrderReturnBankDTOs(page);
        if (!err && data) {
            setModels(data.listObjects);
            setPaging(data.paging);
        } else {
            setModels([]);
            setPaging(page);
        }
    };

    return (
        <Wrapper>
            <Breadcrumbs currentPage="Quản lý hoàn tiền" />
            {_renderTab}
            <section className="table-refund">
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Đơn hàng</th>
                            <th scope="col">Hình ảnh</th>
                            <th scope="col">Lý do hoàn</th>
                            <th scope="col">Thông tin hoàn tiền</th>
                            <th scope="col">Số tiền cần hoàn</th>
                            <th scope="col">Trạng thái</th>
                            <th scope="col">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        {models && models.length > 0 ? (
                            models.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="vertical-align-middle">
                                            <div className="refund-detail">
                                                <a href="#" className="refund-order">
                                                    #{item.orderNumber}
                                                </a>
                                                <span>Mã đơn hàng: {item.orderId}</span>
                                                <span>{item.userName}</span>
                                                <span>{item.phoneNumber}</span>
                                            </div>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <div className="lst-image">
                                                {item.frontImage && <img src={item.frontImage} alt="" />}
                                                {item.backImage && <img src={item.backImage} alt="" />}
                                            </div>
                                        </td>
                                        <td className="vertical-align-middle">{/* <p>Lỗi Ranus</p> */}</td>
                                        <td className="vertical-align-middle">
                                            <div className="bank-info">
                                                <p>
                                                    {item.bankName}
                                                    <br />
                                                    Số tài khoản: {item.bankAccountNumber}
                                                    <br />
                                                    Chủ tài khoản: {item.bankAccountName}
                                                </p>
                                            </div>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <p className="refund-money">
                                                <span>{Common.formatCurrency(item.refundAmount)}</span>
                                            </p>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <div className="badge badge-custom">{item.statusName}</div>
                                        </td>
                                        <td className="vertical-align-middle">
                                            <button
                                                className="btn btn-primary"
                                                onClick={(e) => {
                                                    window.open(`/refund-management-edit/${item.id}`, "_blank");
                                                }}
                                            >
                                                Xem chi tiết
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="7">Không có dữ liệu</td>
                            </tr>
                        )}

                        {/* Add more rows as needed */}
                    </tbody>
                </table>
            </section>
        </Wrapper>
    );
}

export default RefundManagementOverview;

const Wrapper = styled.div`
    tbody tr {
        background: white;
    }

    .bank-info p {
        margin: 0;
    }

    .bank-info {
        width: 300px;
    }

    thead tr th {
        border: 1px solid #d9d9d9;
        background: #d9d9d9;
    }

    section.table-refund {
        margin: 12px 0;
    }

    .refund-detail {
        display: flex;
        flex-direction: column;
        width: 200px;
    }

    .lst-image img {
        width: 90px;
        height: 90px;
        object-fit: contain;
        margin: 5px;
    }

    .lst-image {
    }

    p.refund-money span {
        color: #444;
        text-align: center;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .badge.badge-custom {
        border-radius: 30px;
        background: #28b259;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin: 4px;
    }
`;
